<div [@routeAnimations]="getRouteAnimationData()">
  <router-outlet />
</div>

<!-- Sistema de Notificaciones Global -->
<app-notification />
